<div htcTrapFocus>
  <div
    class="loading"
    [ngClass]="{
      'loading-transition-out': loadingScreenService.loadingScreenState() === 1
    }">
    <div class="loading-bg" #loadingBackground></div>
    <div class="loading-clouds">
      <svg-icon
        class="loading-clouds-cloud cloud-bg"
        src="/assets/loading-images/cloud_bg.svg"></svg-icon>
      <svg-icon
        class="loading-clouds-cloud cloud-mg"
        src="/assets/loading-images/cloud_mg.svg"></svg-icon>
      <svg-icon
        class="loading-clouds-cloud cloud-fg"
        src="/assets/loading-images/cloud_fg.svg"></svg-icon>
    </div>
    <div class="loading-group">
      <h1 id="status">Loading</h1>
      <div class="lds-ellipsis">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</div>
